<template>
  <div>
    <div class="row">
      <!-- Migas -->
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{ $t("integraciones") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("diagnosticoPLU") }}
            </li>
          </ol>
        </nav>
      </div>

      <!-- Filtros negocio / TPV -->
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>{{ $t("negocio") }}</strong></label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="cambioBusiness(); idTpv = -1; idsTPV = []"
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    :key="business.id"
                    :label="business.establishmentName"
                    :value="business.id"
                  />
                </el-select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label><strong>{{ $t("TPV") }}</strong></label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idTpv"
                  filterable
                  @change="tabs === 'Productos' ? getProducts(0) : getSubproducts(0)"
                  :placeholder="$t('seleccionaTpv')"
                >
                  <el-option
                    v-for="tpv in listTpv"
                    :key="tpv.id"
                    :label="tpv.nameShow"
                    :value="tpv.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenido -->
      <template v-if="configTpv">
        <vue-tabs class="col-md-12" v-model="tabs" @tab-change="handleTabChange">
          <v-tab title="" :disabled="true"></v-tab>

          <!-- ===================== TAB PRODUCTOS ===================== -->
          <v-tab title="Productos">
            <div class="row">
              <!-- Buscador productos -->
              <div class="col-md-12 d-flex flex-wrap align-items-end justify-content-between">
                <div class="input-group search-group">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('buscar')"
                    v-model="searchQuery2"
                    @input="debouncedSearchProducts"
                    @keyup.enter.prevent="searchProductos"
                    aria-label="Buscar productos"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-sm"
                      type="button"
                      @click="searchProductos"
                      :disabled="tableLoading"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                    <button
                      class="btn btn-light btn-sm"
                      type="button"
                      @click="removeSearchProduct"
                      :disabled="tableLoading"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Tabla productos -->
              <div class="col-md-12">
                <div class="table-responsive table-sticky">
                  <table class="table table-bordered table-striped text-nowrap">
                    <thead class="thead-dark">
                      <tr>
                        <th class="text-left business-header col-name">
                          {{ $t('nombre') }}
                        </th>
                        <th class="text-center business-header col-plu">PLU1</th>
                        <th class="text-center business-header col-plu">PLU2</th>
                        <th class="text-center business-header col-plu">PLU3</th>
                        <th class="text-center business-header col-plu">PLU4</th>
                        <th
                          v-for="b in businessColumns"
                          :key="b.id"
                          class="text-center business-header col-biz"
                          :title="b.establishmentName"
                        >
                          {{ b.shortName }}
                        </th>
                      </tr>
                    </thead>

                    <tbody v-loading="tableLoading || loadingCompare">
                      <tr v-for="row in comparisonRows" :key="row._key">
                        <!-- Nombre -->
                        <td>
                          <div class="d-flex align-items-center">
                            <strong class="text-truncate name-col">
                              {{ row.name }}
                              <span v-if="row.isInactive" class="baja-flag">[BAJA]</span>
                            </strong>
                            <span
                              v-if="row.nameprice"
                              class="badge badge-light ml-2"
                            >
                              {{ row.nameprice }}
                            </span>
                          </div>
                        </td>

                        <!-- PLUs base -->
                        <td class="text-center plu-col">
                          <span class="plu-text">{{ row.pluSlots[0] || '—' }}</span>
                        </td>
                        <td class="text-center plu-col">
                          <span class="plu-text">{{ row.pluSlots[1] || '—' }}</span>
                        </td>
                        <td class="text-center plu-col">
                          <span class="plu-text">{{ row.pluSlots[2] || '—' }}</span>
                        </td>
                        <td class="text-center plu-col">
                          <span class="plu-text">{{ row.pluSlots[3] || '—' }}</span>
                        </td>

                        <!-- Comparación por negocio -->
                        <td
                          v-for="b in businessColumns"
                          :key="row._key + '_b' + b.id"
                          class="text-center comparison-cell business-cell"
                          :class="getCellClass(row, b.id)"
                        >
                          <template v-if="row.nameCompare && row.nameCompare[b.id]">
                            <!-- Mismo producto por nombre -->
                            <template v-if="row.nameCompare[b.id].status === 'equal'">
                              <span
                                class="badge badge-success"
                                :title="$t('todosPluIguales') || 'Todos los PLU coinciden'"
                              >
                                {{ $t('todosPluIguales') || 'Todos los PLU iguales' }}
                              </span>
                            </template>

                            <!-- Producto encontrado pero con PLUs distintos (incluye caso todos vacíos) -->
                            <template v-else-if="row.nameCompare[b.id].status === 'diff'">
                              <span
                                class="badge badge-danger"
                                :title="row.nameCompare[b.id].diffs
                                  .map(d => 'PLU' + (d.idx + 1) + ': ' + (d.base || '—') + ' ≠ ' + (d.other || '—'))
                                  .join(' ; ')"
                              >
                                {{ $t('pluDiferentes') || 'PLU diferentes' }}:
                                {{ row.nameCompare[b.id].diffs.map(d => 'PLU' + (d.idx + 1)).join(', ') }}
                              </span>
                            </template>

                            <!-- Producto NO encontrado por nombre -->
                            <template v-else-if="row.nameCompare[b.id].status === 'missing'">
                              <div class="cell-not-available">
                                {{ $t('productoNoDisponible') || 'Producto no disponible' }}
                              </div>
                            </template>
                          </template>

                          <!-- Fallback: lógica antigua PLU vs PLU -->
                          <template v-else>
                            <template v-if="row.business[b.id]">
                              <template v-if="row.business[b.id].matchIndex >= 0">
                                <span class="badge badge-success" :title="row.business[b.id].title">
                                  {{ $t('coincide') || 'Coincide' }} (PLU{{ row.business[b.id].matchIndex + 1 }})
                                </span>
                              </template>
                              <template v-else>
                                <span class="badge badge-danger" :title="row.business[b.id].title">
                                  {{ $t('noCoincide') || 'No coincide' }} (PLU: {{ row.business[b.id].value || '—' }})
                                </span>
                              </template>
                            </template>
                            <div v-else class="cell-not-available">
                              {{ $t('productoNoDisponible') || 'Producto no disponible' }}
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="listProducts.length === 0" class="col-md-12">
                <div class="alert alert-danger m-3" role="alert">
                  {{ $t('noProductosSinPLU') || 'No se encontraron productos.' }}
                </div>
              </div>
            </div>
          </v-tab>

          <!-- ===================== TAB MATERIAS PRIMAS ===================== -->
          <v-tab title="Materias Primas">
            <div class="row">
              <!-- Buscador subproductos -->
              <div class="col-md-12 d-flex flex-wrap align-items-end justify-content-between">
                <div class="input-group search-group">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('buscar')"
                    v-model="searchQuerySub"
                    @input="debouncedSearchSubproducts"
                    @keyup.enter.prevent="searchSubproductos"
                    aria-label="Buscar materias primas"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-sm"
                      type="button"
                      @click="searchSubproductos"
                      :disabled="tableLoadingSub"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                    <button
                      class="btn btn-light btn-sm"
                      type="button"
                      @click="removeSearchSubproducto"
                      :disabled="tableLoadingSub"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Tabla materias primas -->
              <div class="col-md-12">
                <div class="table-responsive table-sticky">
                  <table class="table table-bordered table-striped text-nowrap">
                    <thead class="thead-dark">
                      <tr>
                        <th class="text-left business-header col-name">
                          {{ $t('nombre') }}
                        </th>
                        <th class="text-center business-header col-plu">
                          PLU
                        </th>
                        <th
                          v-for="b in businessColumns"
                          :key="'sub_' + b.id"
                          class="text-center business-header col-biz"
                          :title="b.establishmentName"
                        >
                          {{ b.shortName }}
                        </th>
                      </tr>
                    </thead>
                    <tbody v-loading="tableLoadingSub || loadingCompareSub">
                      <tr v-for="row in comparisonRowsSub" :key="row._key">
                        <!-- Nombre subproducto -->
                        <td>
                          <div class="d-flex align-items-center">
                            <strong class="text-truncate name-col">
                              {{ row.name }}
                              <span v-if="row.isInactive" class="baja-flag">[BAJA]</span>
                            </strong>
                          </div>
                        </td>

                        <!-- PLU base (solo uno) -->
                        <td class="text-center plu-col">
                          <span class="plu-text">{{ row.basePlu || '—' }}</span>
                        </td>

                        <!-- Comparación por negocio -->
                        <td
                          v-for="b in businessColumns"
                          :key="row._key + '_sub_b' + b.id"
                          class="text-center comparison-cell business-cell"
                          :class="getCellClassSub(row, b.id)"
                        >
                          <template v-if="row.nameCompare && row.nameCompare[b.id]">
                            <!-- Encontrado con mismo PLU (no vacío) -->
                            <template v-if="row.nameCompare[b.id].status === 'equal'">
                              <span
                                class="badge badge-success"
                                :title="$t('mismoPlu') || 'Mismo PLU'"
                              >
                                {{ $t('mismoPlu') || 'Mismo PLU' }}
                              </span>
                            </template>

                            <!-- Encontrado pero PLU distinto o vacíos -->
                            <template v-else-if="row.nameCompare[b.id].status === 'diff'">
                              <span
                                class="badge badge-danger"
                                :title="'Base: ' + (row.basePlu || '—') + ' ≠ ' + (row.nameCompare[b.id].otherPlu || '—')"
                              >
                                {{ $t('pluDiferentes') || 'PLU diferentes' }}
                              </span>
                            </template>

                            <!-- No encontrado por nombre -->
                            <template v-else-if="row.nameCompare[b.id].status === 'missing'">
                              <div class="cell-not-available">
                                {{ $t('subproductoNoDisponible') || 'Subproducto no disponible' }}
                              </div>
                            </template>
                          </template>

                          <template v-else>
                            <div class="cell-not-available">
                              {{ $t('subproductoNoDisponible') || 'Subproducto no disponible' }}
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="listSubproducts.length === 0" class="col-md-12">
                <div class="alert alert-danger m-3" role="alert">
                  {{ $t('noSubproductosSinPLU') || 'No se encontraron materias primas.' }}
                </div>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </template>

      <!-- Sin acceso -->
      <template v-else>
        <div class="col-md-12">
          <div class="alert alert-primary text-center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>
            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong>.
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
} from "element-ui";
import swal from "sweetalert2";

/* Debounce simple */
function debounce(fn, delay) {
  let t;
  const d = typeof delay === "number" ? delay : 400;
  return function () {
    const args = arguments;
    const ctx = this;
    clearTimeout(t);
    t = setTimeout(function () {
      fn.apply(ctx, args);
    }, d);
  };
}

function normalizeString(s) {
  if (s === undefined || s === null) return "";
  let x = String(s).trim().toLowerCase();
  if (typeof x.normalize === "function") {
    x = x.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  x = x.replace(/\s+/g, " ").replace(/[^\w\s\-\.]/g, "");
  return x;
}

function normalizePlu(v) {
  if (v === undefined || v === null) return "";
  let s = String(v).trim();
  if (!s) return "";
  s = s.replace(/\s+/g, "");
  s = s.toUpperCase();
  if (/^\d+$/.test(s)) {
    s = s.replace(/^0+/, "");
    if (s === "") s = "0";
  }
  return s;
}

export default {
  created() {
    this.loadingCard = true;
    this.$store.dispatch("setNameRoute", this.$i18n.t("diagnosticoPLU"));
    this.tabs = "Productos";
    const vm = this;
    this.getBusiness()
      .then(function () {
        vm.loadingCard = false;
      })
      .catch(function () {
        vm.loadingCard = false;
      });
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      // base
      loading: false,
      loadingCard: false,
      tableLoading: false,
      tableLoadingSub: false,
      tabs: "",
      idBusiness: 0,
      listBusinesses: [],
      query: "",
      listProducts: [],
      listSubproducts: [],
      searchQuery: "",
      searchQuery2: "",
      searchQuerySub: "",
      respuesta: false,
      config98: false,
      config99: false,
      config101: false,
      loadingGeneral: null,
      configTpv: false,
      listTpv: [],
      idsTPV: [],
      idTpv: -1,

      loadingCompare: false,
      loadingCompareSub: false,

      businessMaps: {},       // productos
      businessNameMaps: {},   // productos por nombre
      businessSubMaps: {},    // subproductos
      businessSubNameMaps: {},

      businessFirstTpv: {},
    };
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined) return "—";
      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: "EUR",
        }).format(value);
      } catch (e) {
        return value;
      }
    },
  },
  watch: {
    $route(to) {
      if (to && to.params && to.params.query) {
        this.query = to.params.query;
      }
      if (this.tabs === "Productos") {
        this.getProducts(0);
      } else if (this.tabs === "Materias Primas") {
        this.getSubproducts(0);
      }
    },
  },
  computed: {
    currentBusinessName() {
      for (let i = 0; i < this.listBusinesses.length; i++) {
        const b = this.listBusinesses[i];
        if (b.id === this.idBusiness)
          return b.establishmentName || b.name || "#" + b.id;
      }
      return "#" + this.idBusiness;
    },
    businessColumns() {
      const cols = [];
      for (let i = 0; i < this.listBusinesses.length; i++) {
        const b = this.listBusinesses[i];
        if (b.id === this.idBusiness) continue;
        const full = b.establishmentName || b.name || "#" + b.id;
        cols.push({
          id: b.id,
          establishmentName: full,
          shortName: full, // mostramos nombre completo y dejamos que haga wrap
        });
      }
      return cols;
    },

    /* =================== PRODUCTS COMPARISON ROWS =================== */
    comparisonRows() {
      const rows = [];
      let i, p, key, baselineSlots, j, biz, maps, info, matchIdx, title;

      for (i = 0; i < this.listProducts.length; i++) {
        p = this.listProducts[i];
        key = this.normalizeKey(p);
        baselineSlots = this.extractPLUs(p);

        const businessResult = {};
        for (j = 0; j < this.businessColumns.length; j++) {
          biz = this.businessColumns[j];
          maps = this.businessMaps[biz.id] || {
            byKey: {},
            byName: {},
            byPlu: {},
          };

          info = null;
          // 1) Por PLU
          for (let k = 0; k < baselineSlots.length && !info; k++) {
            const v = baselineSlots[k];
            if (!v) continue;
            if (maps.byPlu[v]) info = maps.byPlu[v];
          }
          // 2) Por key (code / nombre+nameprice)
          if (!info) info = maps.byKey[key];
          // 3) Solo nombre
          if (!info) {
            const nkeyTmp = this.nameOnlyKey(p);
            info = maps.byName[nkeyTmp];
          }
          // 4) Búsqueda difusa
          if (!info) info = this.fuzzyFindByName(maps, p);

          if (info) {
            matchIdx = this.findFirstMatchIndex(baselineSlots, info.plus);
            title =
              "Base: " +
              (baselineSlots.filter((x) => x).join(" / ") || "—") +
              " | " +
              biz.establishmentName +
              ": " +
              (info.plus && info.plus.length ? info.plus.join(" / ") : "—");

            if (matchIdx >= 0) {
              businessResult[biz.id] = {
                matchIndex: matchIdx,
                value: info.plus[0] || "",
                title: title,
              };
            } else {
              businessResult[biz.id] = {
                matchIndex: -1,
                value: info.primary || "",
                title: title,
              };
            }
          } else {
            businessResult[biz.id] = null;
          }
        }

        const keyName = this.nameOnlyKey(p);
        const nameCompare = {};

        for (j = 0; j < this.businessColumns.length; j++) {
          biz = this.businessColumns[j];
          const nameMap = this.businessNameMaps[biz.id] || {};
          const otherSlots = nameMap[keyName];

          if (!otherSlots) {
            nameCompare[biz.id] = { status: "missing" };
          } else {
            const cmp = this.compareSlots(baselineSlots, otherSlots);
            if (!cmp.hasNonEmpty) {
              // Ambos sin PLU -> se considera "diff", no "equal"
              nameCompare[biz.id] = {
                status: "diff",
                diffs: [{ idx: 0, base: "", other: "" }],
                otherSlots,
              };
            } else if (cmp.diffs.length === 0) {
              nameCompare[biz.id] = {
                status: "equal",
                otherSlots,
              };
            } else {
              nameCompare[biz.id] = {
                status: "diff",
                diffs: cmp.diffs,
                otherSlots,
              };
            }
          }
        }

        rows.push({
          _key: key,
          name: p && p.name ? p.name.trim() : "",
          nameprice:
            p && p.nameprice && p.nameprice.trim() !== ""
              ? p.nameprice.trim()
              : "",
          pluSlots: baselineSlots,
          business: businessResult,
          nameCompare: nameCompare,
          isInactive:
            p && p.active !== undefined
              ? parseInt(p.active, 10) === 0
              : false, // [BAJA] si active = 0
        });
      }

      return rows;
    },

    /* =================== SUBPRODUCTS COMPARISON ROWS =================== */
    comparisonRowsSub() {
      const rows = [];
      for (let i = 0; i < this.listSubproducts.length; i++) {
        const s = this.listSubproducts[i];
        const key = this.normalizeKeySub(s);
        const basePlu = this.extractPLUFromSub(s);
        const keyName = this.nameOnlyKey(s);

        const nameCompare = {};
        for (let j = 0; j < this.businessColumns.length; j++) {
          const biz = this.businessColumns[j];
          const nameMap = this.businessSubNameMaps[biz.id] || {};
          const other = nameMap[keyName];

          if (!other) {
            nameCompare[biz.id] = { status: "missing" };
          } else {
            const otherPlu = other.basePlu || "";
            const baseNorm = normalizePlu(basePlu);
            const otherNorm = normalizePlu(otherPlu);
            const hasNonEmpty = !!(baseNorm || otherNorm);

            if (!hasNonEmpty) {
              // ambos vacíos => NO coincide
              nameCompare[biz.id] = {
                status: "diff",
                otherPlu: otherPlu,
              };
            } else if (baseNorm === otherNorm) {
              nameCompare[biz.id] = {
                status: "equal",
                otherPlu: otherPlu,
              };
            } else {
              nameCompare[biz.id] = {
                status: "diff",
                otherPlu: otherPlu,
              };
            }
          }
        }

        rows.push({
          _key: key,
          name: s && s.name ? s.name.trim() : "",
          basePlu: basePlu,
          nameCompare: nameCompare,
          isInactive:
            s && s.active !== undefined
              ? parseInt(s.active, 10) === 0
              : false,
        });
      }
      return rows;
    },
  },
  methods: {
    /* =================== CSS CLASS FOR CELLS =================== */
    getCellClass(row, bizId) {
      const nc = row.nameCompare && row.nameCompare[bizId];
      if (nc) {
        if (nc.status === "equal") return "plu-cell-equal";
        if (nc.status === "diff") return "plu-cell-diff";
        if (nc.status === "missing") return "plu-cell-missing";
      }
      const br = row.business && row.business[bizId];
      if (br) {
        if (br.matchIndex >= 0) return "plu-cell-equal";
        return "plu-cell-diff";
      }
      return "plu-cell-missing";
    },

    getCellClassSub(row, bizId) {
      const nc = row.nameCompare && row.nameCompare[bizId];
      if (!nc) return "plu-cell-missing";
      if (nc.status === "equal") return "plu-cell-equal";
      if (nc.status === "diff") return "plu-cell-diff";
      if (nc.status === "missing") return "plu-cell-missing";
      return "";
    },

    /* =================== SEARCH DEBOUNCE =================== */
    debouncedSearchProducts: debounce(function () {
      if (!this.searchQuery2 || this.searchQuery2.trim() === "") return;
      this.searchProductos();
    }, 500),

    debouncedSearchSubproducts: debounce(function () {
      if (!this.searchQuerySub || this.searchQuerySub.trim() === "") return;
      this.searchSubproductos();
    }, 500),

    /* =================== BUSINESS / TPV LOAD =================== */
    async getBusiness() {
      const config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "general/getBusinessesByUser",
          config
        );
        this.listBusinesses =
          resp.data && resp.data.result ? resp.data.result : [];
        if (this.$store.getters.idBusiness) {
          this.idBusiness = this.$store.getters.idBusiness;
        } else if (this.listBusinesses.length) {
          this.idBusiness = this.listBusinesses[0].id;
        }
        await this.getConfigTpv(98);
        await this.getConfigProductosNoRelacionados();
        await this.getTpv();
      } catch (e) {
        console.log(e);
      }
    },

    async getTpv() {
      this.listTpv = [];
      this.idsTPV = [];
      const config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "general/getTpvsByBusiness",
          config
        );
        if (resp.data && resp.data.response) {
          for (let i = 0; i < resp.data.result.length; i++) {
            const item = resp.data.result[i];
            this.idsTPV.push(item.id);
            this.listTpv.push({ nameShow: item.nameShow, id: item.id });
          }
          this.idTpv = this.idsTPV[0] || -1;

          this.listProducts = [];
          this.listSubproducts = [];

          if (this.tabs === "Materias Primas") {
            await this.getSubproducts(this.idTpv);
          } else if (this.tabs === "Productos") {
            await this.getProducts(this.idTpv);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    /* =================== PRODUCTS API =================== */
    async getProducts(idTpvTem) {
      this.tableLoading = true;
      const controller = this.searchQuery2
        ? "gstock/searchProductos/" + encodeURIComponent(this.searchQuery2)
        : "gstock/getProductos";

      const idTpvSql = idTpvTem !== 0 ? idTpvTem : this.idTpv;
      const config = {
        params: { idTpv: idTpvSql, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "integracion/" + controller,
          config
        );
        if (resp.data && resp.data.response) {
          const arr = resp.data.result || [];
          const list = [];
          for (let i = 0; i < arr.length; i++) {
            const p = arr[i];
            let newPLUBase;
            if (p.newPLU !== undefined && p.newPLU !== null) {
              newPLUBase = String(p.newPLU);
            } else if (p.PLU !== undefined && p.PLU !== null) {
              newPLUBase = String(p.PLU);
            } else {
              newPLUBase = "";
            }
            const clone = Object.assign({}, p);
            clone.newPLU = newPLUBase;
            list.push(clone);
          }
          this.listProducts = list;
          this.respuesta = true;
          await this.loadComparison();
        } else {
          this.respuesta = false;
          swal.fire({
            title: this.$t("atencion"),
            text: resp.data ? resp.data.message : this.$t("error"),
            icon: "error",
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.tableLoading = false;
      }
    },

    /* =================== SUBPRODUCTS API =================== */
    async getSubproducts(idTpvTem) {
      this.tableLoadingSub = true;

      // Ajusta estos endpoints a los tuyos reales
      const controller = this.searchQuerySub
        ? "gstock/searchSubproductos/" + encodeURIComponent(this.searchQuerySub)
        : "gstock/getSubproductos";

      const idTpvSql = idTpvTem !== 0 ? idTpvTem : this.idTpv;
      const config = {
        params: { idTpv: idTpvSql, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "integracion/" + controller,
          config
        );
        if (resp.data && resp.data.response) {
          const arr = resp.data.result || [];
          const list = [];
          for (let i = 0; i < arr.length; i++) {
            const s = arr[i];
            const clone = Object.assign({}, s);
            list.push(clone);
          }
          this.listSubproducts = list;
          this.respuesta = true;
          await this.loadComparisonSub();
        } else {
          this.respuesta = false;
          swal.fire({
            title: this.$t("atencion"),
            text: resp.data ? resp.data.message : this.$t("error"),
            icon: "error",
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.tableLoadingSub = false;
      }
    },

    /* =================== CONFIG TPV =================== */
    async getConfigTpv(numConfig) {
      const config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: numConfig,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        this.$store.dispatch("setIdBusiness", this.idBusiness);
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        );
        if (resp.data && resp.data.response) {
          if (numConfig === 98) this.config98 = resp.data.result;
          else if (numConfig === 99) this.config99 = resp.data.result;
          else if (numConfig === 101) this.config101 = resp.data.result;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async cambioBusiness() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      try {
        await this.getConfigProductosNoRelacionados();
        await this.getTpv();
        await this.loadComparison();
        await this.loadComparisonSub();
      } finally {
        if (this.loadingGeneral) this.loadingGeneral.close();
      }
    },

    async getConfigProductosNoRelacionados() {
      const configIdentificador = 117;
      const config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        );
        if (resp.data && resp.data.response) {
          this.configTpv = resp.data.result;
        } else {
          swal.fire({
            title: this.$t("atencion"),
            text: this.$t("error"),
            icon: "error",
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    handleTabChange() {
      if (this.tabs === "Materias Primas") {
        this.searchQuerySub = "";
        this.getSubproducts(0);
      } else if (this.tabs === "Productos") {
        this.searchQuery2 = "";
        this.getProducts(0);
      }
    },

    /* =================== SEARCH HANDLERS =================== */
    searchProductos() {
      if (this.searchQuery2 !== undefined && this.searchQuery2.trim() !== "") {
        this.getProducts(0);
      }
    },
    removeSearchProduct() {
      if (this.searchQuery2 && this.searchQuery2 !== "") {
        this.searchQuery2 = "";
        this.getProducts(0);
      }
    },

    searchSubproductos() {
      if (
        this.searchQuerySub !== undefined &&
        this.searchQuerySub.trim() !== ""
      ) {
        this.getSubproducts(0);
      }
    },
    removeSearchSubproducto() {
      if (this.searchQuerySub && this.searchQuerySub !== "") {
        this.searchQuerySub = "";
        this.getSubproducts(0);
      }
    },

    /* =================== NORMALIZADORES =================== */
    normalizeKey(p) {
      const code =
        p && (p.code || p.sku || p.reference || p.barcode)
          ? String(p.code || p.sku || p.reference || p.barcode).trim()
          : "";
      if (code) return "code:" + normalizeString(code);

      const name = normalizeString(p && p.name ? p.name : "");
      const np = normalizeString(p && p.nameprice ? p.nameprice : "");
      return "name:" + name + "|" + np;
    },

    normalizeKeySub(s) {
      const code =
        s && (s.code || s.reference || s.barcode)
          ? String(s.code || s.reference || s.barcode).trim()
          : "";
      if (code) return "code:" + normalizeString(code);

      const name = normalizeString(s && s.name ? s.name : "");
      return "name:" + name;
    },

    nameOnlyKey(p) {
      return normalizeString(p && p.name ? p.name : "");
    },

    extractPLUs(p) {
      if (!p) return ["", "", "", ""];
      const s = (x) => normalizePlu(x);
      const slot1 = s(p.PLU1 || p.PLU || p.plu || p.newPLU);
      return [slot1, s(p.PLU2), s(p.PLU3), s(p.PLU4)];
    },

    extractAllPLUs(p) {
      const out = [];
      const push = (val) => {
        const s = normalizePlu(val);
        if (!s) return;
        if (out.indexOf(s) === -1) out.push(s);
      };
      if (!p) return out;

      push(p.PLU1);
      push(p.PLU2);
      push(p.PLU3);
      push(p.PLU4);
      push(p.PLU);
      push(p.plu);
      push(p.newPLU);
      push(p.plu_1);
      push(p.plu_2);
      push(p.plu_3);
      push(p.plu_4);

      try {
        for (const k in p) {
          if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
          const lk = String(k)
            .toLowerCase()
            .replace(/[\W_]+/g, "");
          if (lk.indexOf("plu") !== -1) {
            const v = p[k];
            if (Array.isArray(v)) {
              for (let i = 0; i < v.length; i++) push(v[i]);
            } else {
              push(v);
            }
          }
        }
      } catch (e) {
        /* no-op */
      }

      return out;
    },

    extractPLUFromSub(s) {
      if (!s) return "";
      return normalizePlu(s.PLU || s.plu || s.plu1 || s.newPLU);
    },

    findFirstMatchIndex(baselineSlots, otherPluList) {
      if (!baselineSlots || !otherPluList) return -1;
      for (let i = 0; i < baselineSlots.length; i++) {
        const v = baselineSlots[i];
        if (!v) continue;
        if (otherPluList.indexOf(v) !== -1) return i;
      }
      return -1;
    },

    fuzzyFindByName(maps, baseProduct) {
      if (!maps || !maps.byName) return null;
      let name = baseProduct && baseProduct.name ? String(baseProduct.name) : "";
      name = name
        .toLowerCase()
        .replace(/[^\w\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      if (!name) return null;

      const tokens = name
        .split(" ")
        .filter((t) => t && t.length >= 3);
      if (tokens.length === 0) return null;

      for (const nkey in maps.byName) {
        if (!Object.prototype.hasOwnProperty.call(maps.byName, nkey)) continue;
        const cand = maps.byName[nkey];
        const cname = (cand && cand.name ? String(cand.name) : "")
          .toLowerCase()
          .replace(/[^\w\s]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        let hit = 0;
        for (let i = 0; i < tokens.length; i++) {
          if (cname.indexOf(tokens[i]) !== -1) hit++;
          if (hit >= 2) return cand;
        }
      }
      return null;
    },

    /* Comparación de PLUs (productos) con regla de "todos vacíos => no coincide" */
    compareSlots(baseSlots, otherSlots) {
      const diffs = [];
      let hasNonEmpty = false;
      for (let i = 0; i < 4; i++) {
        const a = baseSlots[i] || "";
        const b = (otherSlots && otherSlots[i]) || "";
        if (a || b) hasNonEmpty = true;
        if (a !== b) {
          diffs.push({ idx: i, base: a, other: b });
        }
      }
      return { diffs, hasNonEmpty };
    },

    /* =================== MAPS POR NEGOCIO =================== */
    buildBusinessNameMap(catalog) {
      const map = {};
      const countFilled = (arr) => {
        let c = 0;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]) c++;
        }
        return c;
      };
      for (let i = 0; i < catalog.length; i++) {
        const p = catalog[i];
        const key = this.nameOnlyKey(p);
        const slots = this.extractPLUs(p);
        if (!map[key]) {
          map[key] = slots;
        } else {
          if (countFilled(slots) > countFilled(map[key])) {
            map[key] = slots;
          }
        }
      }
      return map;
    },

    buildBusinessMaps(catalog) {
      const maps = { byKey: {}, byName: {}, byPlu: {} };
      for (let i = 0; i < catalog.length; i++) {
        const p = catalog[i];
        const key = this.normalizeKey(p);
        const nameKey = this.nameOnlyKey(p);
        const plus = this.extractAllPLUs(p);
        const primary = plus.length ? plus[0] : "";

        const nm = {
          plus: plus,
          primary: primary,
          name: p && p.name ? p.name : "",
          nameprice: p && p.nameprice ? p.nameprice : "",
        };

        if (!maps.byKey[key]) maps.byKey[key] = nm;
        if (!maps.byName[nameKey]) maps.byName[nameKey] = nm;
        for (let j = 0; j < plus.length; j++) {
          const pv = plus[j];
          if (pv && !maps.byPlu[pv]) maps.byPlu[pv] = nm;
        }
      }
      return maps;
    },

    buildBusinessSubNameMap(catalog) {
      const map = {};
      for (let i = 0; i < catalog.length; i++) {
        const s = catalog[i];
        const key = this.nameOnlyKey(s);
        const basePlu = this.extractPLUFromSub(s);
        if (!map[key]) {
          map[key] = { basePlu: basePlu };
        } else {
          // si quisieras, podrías elegir el PLU "mejor", aquí lo dejamos simple
          map[key] = { basePlu: basePlu };
        }
      }
      return map;
    },

    /* =================== LOAD COMPARISON DATA =================== */
    async loadComparison() {
      if (!this.listBusinesses || this.listBusinesses.length === 0) return;

      this.loadingCompare = true;
      const newBusinessMaps = {};
      const newBusinessNameMaps = {};
      const newBusinessFirstTpv = {};

      try {
        for (let i = 0; i < this.listBusinesses.length; i++) {
          const biz = this.listBusinesses[i];
          if (biz.id === this.idBusiness) continue;

          const tpvs = await this.fetchTpvsByBusiness(biz.id);
          newBusinessFirstTpv[biz.id] = tpvs.length ? tpvs[0].id : null;

          let fullCatalog = [];
          for (let t = 0; t < tpvs.length; t++) {
            const cat = await this.fetchAllProductsByTpv(tpvs[t].id);
            if (cat && cat.length) fullCatalog = fullCatalog.concat(cat);
          }

          newBusinessMaps[biz.id] = this.buildBusinessMaps(fullCatalog);
          newBusinessNameMaps[biz.id] = this.buildBusinessNameMap(fullCatalog);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.businessMaps = newBusinessMaps;
        this.businessNameMaps = newBusinessNameMaps;
        this.businessFirstTpv = newBusinessFirstTpv;
        this.loadingCompare = false;
      }
    },

    async loadComparisonSub() {
      if (!this.listBusinesses || this.listBusinesses.length === 0) return;

      this.loadingCompareSub = true;
      const newBusinessSubNameMaps = {};
      const newBusinessFirstTpv = Object.assign({}, this.businessFirstTpv);

      try {
        for (let i = 0; i < this.listBusinesses.length; i++) {
          const biz = this.listBusinesses[i];
          if (biz.id === this.idBusiness) continue;

          const tpvs = await this.fetchTpvsByBusiness(biz.id);
          if (!newBusinessFirstTpv[biz.id]) {
            newBusinessFirstTpv[biz.id] = tpvs.length ? tpvs[0].id : null;
          }

          let fullCatalog = [];
          for (let t = 0; t < tpvs.length; t++) {
            const cat = await this.fetchAllSubproductsByTpv(tpvs[t].id);
            if (cat && cat.length) fullCatalog = fullCatalog.concat(cat);
          }

          newBusinessSubNameMaps[biz.id] =
            this.buildBusinessSubNameMap(fullCatalog);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.businessSubNameMaps = newBusinessSubNameMaps;
        this.businessFirstTpv = newBusinessFirstTpv;
        this.loadingCompareSub = false;
      }
    },

    /* =================== API HELPERS OTHER BUSINESSES =================== */
    async fetchTpvsByBusiness(businessId) {
      const config = {
        params: { idBusiness: businessId, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "general/getTpvsByBusiness",
          config
        );
        if (resp && resp.data && resp.data.response && resp.data.result) {
          return resp.data.result;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },

    async fetchAllProductsByTpv(tpvId) {
      const controller = "gstock/getProductos";
      const config = {
        params: { idTpv: tpvId, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "integracion/" + controller,
          config
        );
        if (resp && resp.data && resp.data.response && resp.data.result) {
          return resp.data.result;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },

    async fetchAllSubproductsByTpv(tpvId) {
      // Ajusta al nombre real de tu endpoint
      const controller = "gstock/getSubproductos";
      const config = {
        params: { idTpv: tpvId, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      try {
        const resp = await this.axios.get(
          this.$store.getters.apiUrl + "integracion/" + controller,
          config
        );
        if (resp && resp.data && resp.data.response && resp.data.result) {
          return resp.data.result;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },

    getSubproductsStub() {
      return Promise.resolve();
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

body {
  background: #1D1F20;
  padding: 16px;
}

.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}

.btn-info {
  background-color: #1E22AA;
}

/* ====== Búsqueda ====== */
.search-group {
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 420px;
}

/* ====== Tabla ====== */
.table-sticky {
  width: 100%;
}

/* Cabecera de columnas */
.business-header {
  white-space: normal;
  word-break: break-word;
  font-size: 0.9rem;
  text-align: center;
  padding: 8px 6px;
}

/* Columna nombre */
.col-name {
  min-width: 260px;
}

/* Columnas PLU (algo más anchas, una línea, sin desbordar) */
.col-plu {
  max-width: 190px;
}

.plu-col {
  max-width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.plu-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Columnas negocios */
.col-biz {
  min-width: 220px;
}

/* Contenido de negocio */
.business-cell {
  font-size: 13px;
  font-weight: 400; /* sin negrita por defecto */
}

/* Columna nombre producto / subproducto */
.name-col {
  max-width: 520px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Aumentamos altura de filas */
.table td {
  padding-top: 10px;
  padding-bottom: 10px;
  vertical-align: middle;
}

/* ====== COLORES CELDAS COMPARACIÓN ====== */
.plu-cell-equal {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.plu-cell-diff {
  background-color: #fd98a0 !important;
  color: #6e000b !important;
}

.plu-cell-missing {
  background-color: #e9ecef !important;
  color: #443f3f !important;
  border: none !important;
}

/* No disponible */
.cell-not-available {
  display: block;
  width: 100%;
  padding: 6px 0;
  text-align: center;
  color: #555 !important;
  background-color: transparent !important;
  border: none !important;
  font-weight: 400; /* sin negrita */
}

/* Badges dentro de celdas equal/diff */
.plu-cell-equal .badge-success,
.plu-cell-diff .badge-danger {
  background-color: transparent !important;
  border: none !important;
  color: inherit !important;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
}

.plu-cell-equal span,
.plu-cell-diff span {
  color: inherit !important;
}

/* Flag [BAJA] */
.baja-flag {
  margin-left: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #721c24;
  background-color: #f8d7da;
  padding: 2px 4px;
  border-radius: 3px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/DiagnosticoPLU/diagnosticoPLU.vue